import React, {ReactNode} from 'react';
import CLOverlayTrigger from '../CLOverlayTrigger/CLOverlayTrigger';
import iconsObj from '../../assets/icons/iconsObj';
import classNames from 'classnames';
import CLMaskIcon from '../CLMaskIcon/CLMaskIcon';
import {Placement} from '@popperjs/core';

interface CLInfoTheme {
  iconClassName?: string;
  tooltipClassName?: string;
}

interface CLInfoProps {
  innerInfoContent: ReactNode;
  theme?: CLInfoTheme;
  placement?: Placement;
}

function CLInfo({innerInfoContent, theme, placement = 'right'}: CLInfoProps) {
  return (
    <CLOverlayTrigger
      trigger="hover"
      popper={innerInfoContent}
      tooltipContainerClassName={theme?.tooltipClassName}
      placement={placement}
    >
      <CLMaskIcon
        src={iconsObj.infoOutlineIcon}
        className={classNames(theme?.iconClassName)}
        bgColor="var(--cl_color_dark_gray)"
      />
    </CLOverlayTrigger>
  );
}

export default CLInfo;
export {CLInfoProps};
